import { Component, effect, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectAuthLoggedIn, selectCurrentDealer, selectLoggedInUserData, selectSameSellerCars } from 'src/app/common/store/state/app.state';

import { MatDialog } from '@angular/material/dialog';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { MessageActions } from 'src/app/common/store/actions/message.actions';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { DealerType } from 'src/app/public/account/constants/dealer-basic-data';
import { ReviewDialogComponent } from 'src/app/public/account/elements/review-dialog/review-dialog.component';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { ReviewReply } from 'src/app/public/account/models/review-reply.model';
import { Review } from 'src/app/public/account/models/review.model';
import { Car } from 'src/app/public/car/models/car.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { CommonBasicData } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource, GeneralBasicData } from 'src/app/public/common/constants/general-basic-data';
import { AppointmentDialogComponent } from 'src/app/public/common/elements/appointment-dialog/appointment-dialog.component';
import { MessageDialogComponent } from 'src/app/public/common/elements/message-dialog/message-dialog.component';
import { Message } from 'src/app/public/common/models/message.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { JobDialogComponent } from 'src/app/public/keep/elements/job-dialog/job-dialog.component';


@Component({
    selector: 'app-dealer-public',
    templateUrl: './dealer-public.component.html',
    styleUrls: ['./dealer-public.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealerPublicComponent implements OnInit{

  CarBusinessLine = CarBusinessLine
  objectSource: ObjectSource = ObjectSource.DEALER
  
  provider$: Observable<Dealer>;
  provider: Dealer = new Dealer();
  providerId: string = '';

  sameSellerCarsToBuy$: Observable<Car[]>;
  sameSellerCarsToRent$: Observable<Car[]>;

  sameSellerCarsToBuy: Car[] = [];
  sameSellerCarsToRent: Car[] = [];

  selectCurrentUser$: Observable<Dealer>;
  
  currentlyLogginIn: boolean = false;
  currentlyLogginUser: Dealer = new Dealer();

  showDetails: boolean = false;

  review: Review = new Review();

  userRatingIndicators = [0,0,0,0,0];

  isFavoriteProvider: boolean = false;
  businessLine: CarBusinessLine = CarBusinessLine.BUY
  DealerType = DealerType;

  currentDealerImage: any

  constructor(

    private store: Store, 
    private router: Router, 
    public dialog: MatDialog,
    private route: ActivatedRoute) {

      route.queryParams.subscribe(params => {
        this.providerId = params['id'];
        this.provider = new Dealer();
        this.store.dispatch(DealerActions.fetchProviderPublicDetailsSubmit({providerId: this.providerId}));

        this.store.dispatch(SearchActions.fetchSameSellerCarsSubmit({sellerId: this.providerId, businessLine: CarBusinessLine.BUY }));

        this.store.dispatch(SearchActions.fetchSameSellerCarsSubmit({sellerId: this.providerId, businessLine: CarBusinessLine.RENT }));

        //this.ratingsIndicators = [0,0,0,0,0];

        if(params['id'] == undefined){
          //this.car = new Car();
          
          this.providerId = '';
        }
        
      });

      this.provider$ = store.select(selectCurrentDealer);

      this.sameSellerCarsToBuy$ = store.select(selectSameSellerCars(CarBusinessLine.BUY));

      this.sameSellerCarsToRent$ = store.select(selectSameSellerCars(CarBusinessLine.RENT));
      //this.carImagesFolder$ = store.select(selectImagesFolderByCarId(this.providerId));  

      this.selectCurrentUser$ = store.select(selectLoggedInUserData);

    }

    ngOnInit(): void {

      this.provider = new Dealer();

      this.provider$.subscribe(
        (owner: Dealer) => {
            //this.provider = new Dealer();
            console.log(owner)
            this.provider = owner;
            // let avgRating = AppFunctions.getRatingsAverage(this.provider.ratingsCounts);
            
            // let i = 4;
            
            // while(i >= 0){
              
            //    this.ratingsIndicators[i] = (avgRating > i)? 1:0;
            //   i--;
            // }

            //this.ratings = Array(5).fill(0).map((x,i) => (rating > i)? 1:0 );

            //this.ratingsIndicators[Math.floor(avgRating)] = avgRating-Math.floor(avgRating);

            this.isFavoriteProvider = !(this.currentlyLogginUser.favoriteProviderIds.find(x => this.provider.username === x) == undefined);
  
        });

        this.selectCurrentUser$.subscribe(
          (user: Dealer) => {

            this.currentlyLogginIn = (user.username !== '');
            this.currentlyLogginUser = user;
            this.isFavoriteProvider = !(this.currentlyLogginUser.favoriteProviderIds.find(x => this.provider.username === x) == undefined);

          }
        );

        this.sameSellerCarsToBuy$.subscribe(
          (res: Car[]) =>  {
            this.sameSellerCarsToBuy = res.map(c => Object.assign(new Car(), c));
          }
        );  

        this.sameSellerCarsToRent$.subscribe(
          (res: Car[]) =>  {
            this.sameSellerCarsToRent = res.map(c => Object.assign(new Car(), c));
          }
        );  
      }  

    dateFormat(dt: string): string{

      return AppFunctions.stringToDatetime(dt);
    }

    getCountryName(code: string): string{
      return GeneralBasicData.getCountryByCode(code)?.name!;
    }


    getSellerRatingsTotalCount(): number{
      return this.provider.ratingsSummary.counts.reduce((a, b) => a + b, 0);
    }

    recordRating(rate: number){
      //alert(rate);

      //this.store.dispatch(DealerActions.addNewReviewSubmit({rate: rate, providerId: this.provider.username}));

      
    }

    openMessageFormDialog(): void {

      let msg = new Message();
      msg.senderId = this.currentlyLogginUser.username
      const dialogRef = this.dialog.open(MessageDialogComponent, {
        data: msg
      });
  
      dialogRef.afterClosed().subscribe((result: any) => {
  
        //console.log('New price = '+result+ " car Id = "+carId);
        if(result != undefined ){
          console.log(result);
          result.receiverId = this.provider.username
          this.store.dispatch(MessageActions.sendNewMessageSubmit( { message: result, objectSource: ObjectSource.DEALER }));
        }  
      });
    }

    openAppointmentDialog(): void {
    
        //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
        let objectData: ObjectData = new ObjectData(this.objectSource, "", 0);
    
        const dialogRef = this.dialog.open(AppointmentDialogComponent, {
          data: objectData
        });
      }

    openJobDialog(offerId: string, jobId: string){

      console.log(offerId)
        
      const dialogRef = this.dialog.open(JobDialogComponent, {
  
        data: new ObjectData(this.objectSource, offerId, +jobId, CarBusinessLine.KEEP, "")
  
      });
    }

    openReviewDialog(rev: any, index: number): void {
      // console.log(review.status)
      // let review = new Review();
      // if(review.status == undefined){
      //   review = new Review();
      // }
      console.log('index = '+index) 
      
      
      let review: Review = new Review();
      console.log(" rev = "+JSON.stringify(review));
      

      if(index >= 0){
        review = JSON.parse(JSON.stringify(rev));
        review.newReply = new ReviewReply();
      }
        
      //Object.assign(new Dealer(), this.dealerData)
      const dialogRef = this.dialog.open(ReviewDialogComponent, {
        data: review
      });
  
      dialogRef.afterClosed().subscribe((result: Review) => {
  
        console.log(" result = "+JSON.stringify(result));
        
        if(result != undefined ){
          if(result!.rate < 1  || result!.rate > 5){
            alert("Veuillez choisir la note");
            return;
          }

          if(index >= 0 && result.newReply.comment !== undefined){
            
            this.store.dispatch(DealerActions.reviewReplySubmit({ reviewId: result.id, reply: result.newReply}));
          }
          else if(index === -1 ){
            result.ratedId = this.provider.username;
            this.store.dispatch(DealerActions.reviewAddSubmit({ review: result }));
          } 
    
        }  
      });
    }

    recordReview(){
      //alert(rate);
      if(this.review.rate < 1  || this.review.rate > 5){
        alert("Veuillez choisir la note");
        return;
      }
      
      ////this.store.dispatch(DealerActions.addNewReviewSubmit({review: this.review}));

      this.review = new Review();
    }

    recordReviewN(review: Review){
      if(review.rate < 1  || review.rate > 5){
        alert("Veuillez choisir la note");
        return;
    }
    review.ratedId = this.provider.username;
    this.store.dispatch(DealerActions.reviewAddSubmit({ review: review }));  
  }

  toggleFavoriteProvider(){
    this.store.dispatch(DealerActions.toggleFavoriteProviderSubmit({providerId: this.provider.username, makeFav: !this.isFavoriteProvider}));
  }

  getServiceTypeTitle(code: string): string{
    return CommonBasicData.getServiceTypeTitle(code)!;
  }

  // isFavoriteProvider(): boolean{
  //   return (this.currentlyLogginUser.favoriteProviders.find(x => this.provider.username === x) == undefined)
  // }

}
